// API Configuration
// This file centralizes the API URL configuration

// Function to get API URL - called at runtime
export const getApiUrl = () => {
  // First check if environment variable is set (from Vercel)
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) {
    console.log('Using REACT_APP_API_URL:', envUrl);
    return envUrl;
  }
  
  // Runtime detection based on hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    console.log('Detecting environment from hostname:', hostname);
    
    // If running on localhost, use local backend
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      console.log('Using localhost API');
      return 'http://localhost:5000/api';
    }
  }
  
  // Default to production API for all other cases
  console.log('Using production API: https://api.kanivuekm.com/api');
  return 'https://api.kanivuekm.com/api';
};

// Export as a constant that calls the function
// This ensures it's evaluated at runtime in the browser
export const API_URL = getApiUrl();

// Log for debugging
console.log('Final API_URL:', API_URL);
